import React from 'react'

const CheckColors = () => {
    return (
        <svg width="50" height="50" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.875 26.125L26.125 40.375L49.875 16.625" stroke="white" strokeWidth="4.75" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default CheckColors